import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Text } from 'components/Ui-Kits/Text'
import { useAuctionSublingProduct } from 'hooks/data/auction/useAuctionProducts'
import { useAppTranslation } from 'i18n/hooks'
import { number } from 'prop-types'
import { useHistory, useParams } from 'react-router'
import styled from 'styled-components'

export const ProductSwitcher = ({ sort }) => {
  const { auctionId } = useParams()
  const { product: prevProduct } = useAuctionSublingProduct(auctionId, sort, 'desc')
  const { product: nextProduct } = useAuctionSublingProduct(auctionId, sort, 'asc')
  const { t } = useAppTranslation()
  const history = useHistory()

  return (
    <>
      <Wrap>
        <ItemWrap
          disabled={!prevProduct}
          onClick={() => prevProduct && history.push(`/auction/${auctionId}/${prevProduct.id}`)}
        >
          <Icon icon={faArrowLeft} />
          <Text color="primary" size={1} uppercase bold>
            {t('prevItem')}
          </Text>
        </ItemWrap>
        <ItemWrap
          disabled={!nextProduct}
          onClick={() => nextProduct && history.push(`/auction/${auctionId}/${nextProduct.id}`)}
        >
          <Text color="primary" size={1} uppercase bold>
            {t('nextItem')}
          </Text>
          <Icon icon={faArrowRight} />
        </ItemWrap>
      </Wrap>
    </>
  )
}

ProductSwitcher.propTypes = {
  sort: number,
}

const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  align-items: center;
  margin-bottom: 2rem;
`
const ItemWrap = styled.div`
  gap: 0.5rem;
  display: flex;
  flex-direction: row;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  align-items: center;
`
const Icon = styled(FontAwesomeIcon)`
  font-size: 0.875rem;
  color: var(--color-primary);
`
